import ReactPDF, { Document, Page } from '@react-pdf/renderer'
import moment from 'moment'
import React from 'react'

import { ConselhoClasseImpressao, PrinterType } from '../model'
import { PrintBody } from '../PrintBody'
import { PrintFooter } from '../PrintFooter'
import { PrintHeader } from '../PrintHeader'
import { usePrinterStyles } from '../usePrinterStyles'

export interface PecPrintPageLayoutProps {
  documentTitle?: string
  pageProps?: ReactPDF.PageProps
  bodyStyles?: ReactPDF.Style
  showSign?: boolean
  session?: PrinterType
  children?: React.ReactNode
  nameFooter?: string
}

export const PecPrintPageLayout = (props: PecPrintPageLayoutProps) => {
  const { children, documentTitle, pageProps, bodyStyles, showSign, session, nameFooter } = props
  const { config } = usePrinterStyles()
  const today = moment()

  const nomeProfissional = session.profissional.nome
  const nomeCbo = session.acesso.__typename === 'Lotacao' && session.acesso.cbo?.nome
  const nomeUnidadeSaude = session.acesso.__typename === 'Lotacao' && session.acesso.unidadeSaude.nome
  const nomeMunicipio = session.acesso.municipio.nome
  const nomeMunicipioUf = session.acesso.municipio.uf.nome
  const conselhoClasse: ConselhoClasseImpressao = session.acesso.__typename === 'Lotacao' && {
    numero: session.profissional?.numeroConselhoClasse,
    sigla: session.profissional.conselhoClasse?.sigla,
    uf: {
      nome: session.profissional.ufEmissoraConselhoClasse?.nome,
      sigla: session.profissional.ufEmissoraConselhoClasse?.sigla,
    },
  }

  return (
    <Document title={documentTitle} author={nomeProfissional} creator='PEC eSUS-APS'>
      <Page style={{ ...config.page }} size='A4' {...pageProps}>
        <PrintHeader ufNome={nomeMunicipioUf} municipio={nomeMunicipio} unidadeSaude={nomeUnidadeSaude} />
        <PrintBody
          styles={bodyStyles}
          showSign={showSign ?? true}
          nomeProfissional={nomeProfissional}
          cboProfissional={nomeCbo}
          conselhoClasse={conselhoClasse}
        >
          {children}
        </PrintBody>
        <PrintFooter
          data={today.format('DD/MM/YYYY')}
          hora={today.format('HH:mm')}
          nomeProfissional={nameFooter ?? nomeProfissional}
        />
      </Page>
    </Document>
  )
}
